import { FILTERABLE_ENTITY_TYPES } from 'advanced-filters/data';
import type { FilterForm } from 'advanced-filters/store/filter';

export const hasSubCondition = (
  conditionKey: FilterForm['conditionKey'] | undefined,
  conditionValue: FilterForm['conditionValue'],
) => {
  if (!conditionKey?.hasSubCondition) {
    return false;
  }

  if (!conditionValue?.value || conditionValue.value.length === 0) {
    return false;
  }

  if (conditionKey.entityType === FILTERABLE_ENTITY_TYPES.leadActivity && conditionValue.value[0]?.value === 'any') {
    return false;
  }

  return true;
};
